export default{sources:{avif:"__VITE_ASSET__BB0W7iZS__ 400w",webp:"__VITE_ASSET__DdCKcRpw__ 400w"},img:{src:"__VITE_ASSET__CAkbz7$l__",w:400,h:267}};